export default {
  startsOnNewPage: 'Začať na novej strane',
};
